module.exports = __webpack_public_path__ + "img/participant-picture@dt-3.4dd0b18.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participant-picture@dt-3.svg
// module id = R57W
// module chunks = 0